<opac-card-item
  *ngIf="record()"
  [title]="record().title"
  [author]="record().author"
  [cover]="{ url: record().coverImageUrl, icon: record().icon }"
  [link]="record() | infoUrl"
>
  <opac-card-item-social>
    <app-rating [record]="record()"></app-rating>
    <app-more-option-button [showCiteButton]="true" [showReportButton]="true" [recordItem]="record()" [showFavoriteButton]="false"></app-more-option-button>
  </opac-card-item-social>

  <opac-card-item-details>
    <opac-card-item-detail [label]="'user.favorites.dateAdded' | translate">{{ favorite.date | date }}</opac-card-item-detail>
  </opac-card-item-details>

  <div class="actions">
    <app-record-buttons
      *ngIf="favorite.availableForCheckout"
      [from]="'USER_SCREENS'"
      [record]="record()"
      [config]="buttonConfig"
    ></app-record-buttons>

    <app-remove-button [favorite]="favorite" (removed)="onItemRemoved()"></app-remove-button>

    <span *ngIf="!favorite?.availableForCheckout" class="not-available-tag">
      {{ "general.notAvailable" | translate }}
    </span>
  </div>
</opac-card-item>
